import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateUI } from 'store/UI/actions';
import styled from 'styled-components';

const EngagePgEditor = ({ name, engage = [] }) => {
  const [namePg, setNamePg] = useState(Number(name));
  const dispatch = useDispatch();
  const showAlert = useAlert();

  useEffect(() => {
    setNamePg(Number(name));
  }, [name]);

  const handleChange = (e) => {
    setNamePg(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const numberValue = Number(namePg);
      if (numberValue !== name) {
        const findEngage = engage.find((item) => Number(item.sequence) === Number(numberValue)) || {};
        
        if(!findEngage?.id) {
          showAlert('No Engage found with this number');
          return;
        }
        dispatch(
          updateUI({
            openEngageModalTeacher: {
              open: true,
              id: findEngage?.id,
              engagePageId: findEngage?.pageId, 
              data: findEngage?.imageData,
              engageName: findEngage?.sequence,
            },
          }),
        );
      }
    }
  };

  return (
    <span>
      Engage
      <Input
        value={namePg}
        disabled={false}
        type="number"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
    </span>
  );
};

const Input = styled.input`
  background-color: transparent;
  border: 1px dashed transparent;
  border-radius: 3px;
  box-shadow: none;
  font-size: inherit;
  font-weight: 600;
  outline: none;
  padding: 0px 2px;
  transition: all 300ms ease;
  width: fit-content;
`;

export default EngagePgEditor;
